module.exports = __webpack_public_path__ + "img/login-illustration.3bc9bb27.jpeg";